import { MailOutlined } from '@ant-design/icons'
import FormCard from '@components/FormCard'
import Page from '@components/Page/Page'
import { NotificationContentKey } from '@models/NotificationContent'
import { useAppDispatch } from '@store/hooks'
import { getNotificationContents } from '@store/NotificationContentReducer'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { Permission } from '@utils/permissions'
import { Card, Col, Typography } from 'antd'
import { useEffect } from 'react'

const { Text } = Typography

const PaymentLinkPage = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      getNotificationContents([
        NotificationContentKey.RESERVATION_PAYLINK_NOTE_TO_GUEST,
      ])
    )
  }, [])

  return (
    <Page
      permissions={Permission.listSeatingArea}
      pageTitle={{
        title: 'Payment link',
        level: 4,
      }}
      noWrapWithCol
    >
      <Col span={12}>
        <FormCard
          title="Note to guest"
          icon={<MailOutlined />}
          entity={Entity.notificationContent}
          action={SBRMAction.Update}
          footer={
            <Card styles={{ body: { padding: 10 } }}>
              <Text type={'secondary'}>
                This content will appear in the payment request email.
              </Text>
            </Card>
          }
          metadata={[
            {
              key: MetadataKey.NotificationContent,
              value: NotificationContentKey.RESERVATION_PAYLINK_NOTE_TO_GUEST,
            },
          ]}
        />
      </Col>
    </Page>
  )
}

export default PaymentLinkPage
